<template>
  <form @submit.prevent="changepassword">
		<div class="form_box">
			<table>
				<tr>
					<th>現在のパスワード</th>
  			  <td><p><input type="password" v-model="oldPassword" required></p></td>
				</tr>
				<tr>
					<th>新しいパスワード</th>
					<td>
  				  <p><input type="password" v-model="password" required></p>
  					<p><input type="password" v-model="passwordConfirm" placeholder="確認用" required></p>
					</td>
				</tr>
			</table>
			<p class="submit"><input type="submit" value="変更する"></p>
		</div>
	</form>
</template>

<script>
export default {
  name: 'ChangePassword',
  data () {
    return {
      oldPassword: '',
      password: '',
      passwordConfirm: ''
    }
  },
  methods: {
    changepassword () {
      if (this.password === this.passwordConfirm) {
        this.$cognito.changePassword(this.oldPassword, this.password)
          .then(result => {
            this.$router.replace('/home')
            this.$notify({ group: 'main', text: 'パスワードを更新しました。' })
          })
          .catch(err => {
            this.$notify({ group: 'main', type: 'error', text: this.$i18n.t("message.change-password." + err.code) })
          })
      } else {
        this.$notify({ group: 'main', type: 'error', text: this.$i18n.t("message.PasswordNotSameException") })
      }
    },
    logout () {
      this.$cognito.logout
      this.$router.replace('/')
    }
  }
}
</script>

<style scoped>
  @import '../assets/css/user.css'
</style>



// WEBPACK FOOTER //
// src/components/ChangePassword.vue